<template>
  <div
    class="inline-flex items-center gap-1 rounded-full border bg-card p-1 shadow-sm"
  >
    <button
      type="button"
      class="whitespace-nowrap rounded-full px-4 py-1.5 text-[13px] font-semibold transition-colors"
      :class="
        !isAnnual
          ? 'bg-primary text-primary-foreground'
          : 'text-muted-foreground hover:text-foreground'
      "
      @click="isAnnual = false"
    >
      {{ $t("common.monthly") }}
    </button>
    <button
      type="button"
      class="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-1.5 text-[13px] font-semibold transition-colors"
      :class="
        isAnnual
          ? 'bg-primary text-primary-foreground'
          : 'text-muted-foreground hover:text-foreground'
      "
      @click="isAnnual = true"
    >
      {{ $t("common.annual") }}
      <span
        class="whitespace-nowrap rounded px-1.5 py-0.5 text-[11px] font-medium"
        :class="
          isAnnual ? 'bg-white/20 text-primary-foreground' : 'bg-primary/10 text-primary'
        "
        >{{ $t("authentication.extensionLink.yearlyBadge", { percent: PRO_YEARLY_SAVINGS_PERCENT }) }}</span
      >
    </button>
  </div>
</template>

<script setup lang="ts">
import { PRO_YEARLY_SAVINGS_PERCENT } from "~/constants/pricing";

const props = defineProps<{ modelValue: boolean }>();
const emit = defineEmits<{ "update:modelValue": [value: boolean] }>();

const isAnnual = computed({
  get: () => props.modelValue,
  set: (v) => emit("update:modelValue", v),
});
</script>
